import axios from "axios";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import useOpenSnackbar from "custom-hooks/snacbar/useOpenSnackbar";

export function useSignup() {
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
    useOpenSnackbar();
  const [signUpData, setSignUpData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const { mutate, isLoading } = useMutation(
    (data) =>
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/user/register`, data)
        .then((res) => {
          return res.data;
        }),
    {
      onSuccess: (response) => {
        setOpenModal(true);
      },
      onError: (error)=>{
          openSnackbar('error', error?.response?.data?.message)
      }
    }
  );
  const _signUp = (data) => {
    setSignUpData(data);
    mutate(data);
  };

  return {
    severity, message, openToast, setOpenToast, duration,
    signUpData,
    openModal,
    setOpenModal,
    loading: isLoading,
    signUp: _signUp,
  };
}
